/* eslint-disable @typescript-eslint/no-throw-literal */
import TableNoDataError from '../errors/no-data';

import Column from './column';

function lensRowsPath(contentType, columnName, mode) {
  return ['tables', contentType, 'content', columnName, 'modes', mode, 'rows'];
}

class Table {
  constructor($pool, $plugins, tableName) {
    this.node = null;
    this.columns = {};
    this.name = tableName;

    this.$pool = $pool;
    this.$plugins = $plugins;
  }

  makeColumn(columnName, columnMode, rows) {
    return new Column(
      this.$pool,
      this.$plugins,
      columnName,
      columnMode
    ).connect(rows);
  }

  connect(node, columns) {
    this.columns = Object.values(columns).reduce((acc, column) => {
      const modeName = Object.keys(column.modes)[0];
      acc[column.name] = this.makeColumn(
        column.name,
        modeName,
        column.modes[modeName].rows
      );
      return acc;
    }, {});

    this.node = node;

    return this;
  }

  changeMode(columnName, mode, newMode, $dataProxy, next) {
    if (!Object.hasOwnProperty.call(this.columns, columnName))
      throw new TableNoDataError({
        columnName,
        mode,
        newMode,
        message: `No column ${columnName}`,
      });

    const data = $dataProxy.path(lensRowsPath(this.name, columnName, mode));
    const newData = $dataProxy.path(
      lensRowsPath(this.name, columnName, newMode)
    );

    if (data == null || newData == null)
      throw new TableNoDataError({
        columnName,
        mode,
        newMode,
        message: `No data [${columnName}][${newMode}]`,
      });

    this.$plugins.emit('Table:changeMode', {
      tableName: this.name,
      node: this.node,
      columnName,
      newMode,
      mode,
    });

    this.columns[columnName].changeMode(
      mode,
      newMode,
      {
        [mode]: data,
        [newMode]: newData,
      },
      next
    );
  }
}

export default Table;
